<template>
  <div class="animated fadeIn">
       <b-row>
          <b-col lg="12">
                <!-- <b-alert :show="dismissCountDown"
                        dismissible
                        :variant="response.success== true ? 'success':'danger'"
                        @dismissed="dismissCountdown=0"
                        @dismiss-count-down="countDownChanged">
                  <p v-if="response.errors">{{response.errors}}</p>
                  <hr v-if="response.errors">
                  <p class="mb-0" v-if="response.errors">     
                    <strong>{{response.message}}</strong>
                  </p>
                <strong v-if="!response.errors">{{response.message}}</strong>
              </b-alert> -->
            <b-card>
              <div slot="header">
                Consultation des <strong>opérations</strong>  
              </div> 
             <b-row class="form-group"> 
                  <b-form-group>         
                    <b-input-group>
                      
                      <span style="margin-left:0%;"></span>
                      <b-input-group-prepend><b-input-group-text>Date du</b-input-group-text></b-input-group-prepend>
                      <!-- <datepicker v-model="date_setting.date_du"></datepicker><span style="padding-left:1px;padding-right:1px;"></span> -->
                      <el-date-picker
                        v-model="serverParams.date_du"
                        type="date"
                        placeholder="Choisir une date"
                        format="dd/MM/yyyy"
                        :picker-options="pickerOptions1">
                      </el-date-picker><span style="padding-left:1px;padding-right:1px;"></span>
                      <!-- <b-form-input type="date" placeholder="Date du " id="date_du" v-model="serverParams.date_du"></b-form-input><span style="padding-left:1px;padding-right:1px;"></span> -->
                      <b-input-group-prepend><b-input-group-text>Au</b-input-group-text></b-input-group-prepend>
                      <el-date-picker
                        v-model="serverParams.date_au"
                        type="date"
                        placeholder="Choisir une date"
                        format="dd/MM/yyyy"
                        :picker-options="pickerOptions1">
                      </el-date-picker><span style="padding-left:1px;padding-right:1px;"></span>
                      <!-- <b-form-input type="date" placeholder="Date au" v-model="serverParams.date_au"></b-form-input><span style="padding-left:1px;padding-right:1px;"></span> -->
                      <!-- Attach Right button -->
                      <b-input-group-append>
                          <b-button variant="primary" @click.prevent="loadItems()"><i class="fa fa-search"></i> Actualiser</b-button><span style="padding-left:6px;padding-right:1px;"></span>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
              </b-row>
            </b-card>
        </b-col>
    </b-row>
    
      <b-row>
        <b-col sm xs="12" class="text-left mt-3">
          <router-link to="/approvisionnement/create" v-if="can('approvisionnement-create')">
            <b-button variant="primary" class="btn-pill">
              <i class="fa fa-plus"></i>&nbsp;Nouveau
            </b-button>
          </router-link>
          <router-link to="/approvisionnements/entite" v-if="can('approvisionnement-entite-list')">
            <b-button variant="primary" class="btn-pill">
              <i class="fa fa-eye"></i>&nbsp;Appro Entite
            </b-button>
          </router-link>
          <router-link to="/approvisionnements/guichet" v-if="can('approvisionnement-guichet-list')">
            <b-button variant="primary" class="btn-pill">
              <i class="fa fa-eye"></i>&nbsp;Appro Guichet
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    
    <b-row>
     <b-col lg="12">
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
          <div>
              <vue-good-table :columns="columns" styleClass="vgt-table condensed bordered striped" :rows="rows" :fixed-header="false" :pagination-options="pagination" :search-options="search" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"/>
              <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">
                    <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                            <div role="group" aria-lableledby="header1">                   
                              <router-link :to="'/historique/approvisionnement/'+ props.row.id">
                                <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-users"></i> Historique des activités</b-dropdown-item-button>
                              </router-link>
                          </div>
                        </b-dropdown> 
                  </span>
                  <span style="font-size: 0.875rem;" v-else>
                    {{props.formattedRow[props.column.field]}}
                  </span> 
              </template> 
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
//import cTableEntities from './TableEntities.vue'
import { VueGoodTable } from 'vue-good-table';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'tables',
  //components: {cTableEntities},
  components: {VueGoodTable},
   data(){
    return {
      totalRecords :0,
      user_id:'',
      columns: [
        {
          label: 'Utilisateur',
          field: 'user_nom',
          width: '200px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Agence Source',
          field: 'agence_nom_source',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Guichet Source',
          field: 'guichet_nom_source',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Ville Source',
          field: 'agence_ville_source',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
      
        {
          label: 'Destination',
          field: 'destination',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Montant',
          field: 'montant',
          width: '150px',
          filterable: true,
          type: 'number',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },       
        {
          label: 'Type',
          field: 'approvisionnementable_type',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Crée le',
          width: '150px',
          field: 'created_at',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'YYYY-MM-DD',
          formatFn: this.formatFn,
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Action',
          field: 'btn',
          html: true,
          width: '150px',
        }
      ],
      rows: [],
      pagination:{
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [3,5, 10, 50,100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
      },
      search:{
          enabled: false,
          trigger: 'keyup',
          placeholder: 'Rechercher dans la table',
      },
      serverParams: {
        user:'',
        montant:'',
        approvisionnementable_type:'',
        approvisionnementable:'',
        date_du:'',
        date_au:'',
        created_at:'',
        page:1,
        current_page: 1,
        nb_lines: 10
      },
      pickerOptions1: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          shortcuts: [{
            text: "Aujourd'hui",
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: 'Hier',
            onClick(picker) {
              const date = new Date();
              
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: 'Semaine avant',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
      }
    };
  },
  computed: mapState({
    agencies: state => state.atm.all
  }),
  created () {
    
    
  },
  methods:{
    formatFn: function (value) {
        return value != null ? value : null
    },
    async get_all_approvisionnements(){
      this.user_id = this.$route.params.user_id
      this.$store.dispatch('appro/get_all_approvisionnements_by_users',this.$route.params.user_id).then(()=>{
          return this.rows =  store.getters['appro/rows'];
      })
    },
    can(perm){
      return store.getters['auth/can'](perm)
    },
    setting(){
      var q = new Date();
      var m = q.getMonth();
      var d = q.getDate();
      var y = q.getFullYear();
      var date = new Date(y,m,d);
      this.serverParams.date_au = this.serverParams.date_du=date
    },
    updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.serverParams.page = params.currentPage
      this.updateParams({page: params.currentPage,current_page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.serverParams.nb_lines = params.currentPerPage
      console.log(params)
      this.updateParams({page: params.currentPage,paginate:params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
    this.updateParams({
      sort: {
        type: params.sortType,
        field: this.columns[params.columnIndex].field,
      },
    });
    this.loadItems();
    },    
    onColumnFilter(params) {
      this.serverParams.user_nom=params.columnFilters.user_nom
      this.serverParams.agence_nom_source=params.columnFilters.agence_nom_source
      this.serverParams.agence_ville_source=params.columnFilters.agence_ville_source
      this.serverParams.agence_nom_destination=params.columnFilters.agence_nom_destination
      this.serverParams.guichet_nom_source=params.columnFilters.guichet_nom_source
      this.serverParams.destination=params.columnFilters.destination
      this.serverParams.montant=params.columnFilters.montant
      this.serverParams.approvisionnementable_type=params.columnFilters.approvisionnementable_type
      // this.serverParams.montant=params.columnFilters.montant,
      this.serverParams.created_at=params.columnFilters.created_at
      this.updateParams(params);
      this.loadItems();
    },
      // load items is what brings back the rows from server
    async loadItems() {
      this.serverParams.user_id =await this.$route.params.user_id
      console.log('server Params ',this.serverParams)
      this.$store.dispatch('appro/get_all_approvisionnements_by_users',this.serverParams).then((response)=>{
        this.totalRecords = response.total;
        return this.rows = store.getters['appro/rows'];
      })
    }
  },
  mounted(){
    this.setting()
    this.get_all_approvisionnements()
  }
  
}
</script>
